import React, { useEffect, useState } from "react";
import { Carousel } from "primereact/carousel";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { Divider } from "primereact/divider";
import ADPMemoService from "../services/admin/ADPMemoService";
import bulletinService from "./admin/user_setting/office_automation/bulletin/bulletin-service";
import { useToast } from "../components/Toast";

interface Memo {
    id: number;
    image: string;
    remark: string;
    date: string;
}

interface RecordFilter {
    [key: string]: string | boolean | Date; // Adjust types as needed
}

const LandingPage: React.FC = () => {
    const [gridDataSource, setGridDataSource] = useState<any[]>([]);
    const [clientState, setClientState] = useState<any>(null);
    const { showToast } = useToast();
    const [isValid, setIsValid] = useState<boolean>(true);
    const [activeIndex, setActiveIndex] = useState(0);

    const [recordFilter, setRecordFilter] = useState<RecordFilter>({});

    useEffect(() => {
        const fetchClientState = async () => {
            try {
                const clientStateItem = await bulletinService.getClientState();
                setClientState(clientStateItem);

            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, []);

    useEffect(() => {
        if (clientState) {
            const fetchUserList = async () => {

                if (recordFilter.dateFrom !== null && recordFilter.dateTo !== null) {
                    if (recordFilter.dateFrom > recordFilter.dateTo) {
                        setIsValid(false);
                    } else {
                        setIsValid(true);
                        try {

                            //Add filter
                            // recordFilter.facilityCode = clientState.facilityCode;

                            bulletinService.findAll(recordFilter).then((data) => {
                                setGridDataSource(data);
                            });
                        } catch (error) {
                            showToast(clientState.error);
                        }
                    }
                }
            };

            fetchUserList();
        }
    }, [clientState, recordFilter]);

    useEffect(() => {
        if (gridDataSource.length > 1) {
            const interval = setInterval(() => {
                setActiveIndex((prevIndex) => (prevIndex + 1) % gridDataSource.length);
            }, 2000);
            return () => clearInterval(interval);
        }
    }, [gridDataSource]);

    const memoTemplate = (memo: any) => {


        const cleanHtmlContent = (raw: string) => {
            try {
                // If the string is wrapped in quotes, remove them
                if (raw.startsWith('"') && raw.endsWith('"')) {
                    raw = raw.slice(1, -1);
                }

                // Replace escaped quotes (\" → ")
                return raw.replace(/\\"/g, '"');
            } catch (e) {
                return raw;
            }
        };

        // const imageUrl = Buffer.from(memo.imageUrl).toString();
        const imageUrl = new TextDecoder().decode(new Uint8Array(memo?.imageUrl?.data));

        return (
            <div className="flex items-center p-4 border-round-lg w-full h-full">
                {/* Text Section */}
                <div className="text-left p-2 h-36 border-black">
                    <div className="flex gap-4 justify-center text-sm text-gray-600 mb-2">
                        <div className="flex items-center gap-1">
                            {/* <span className="font-medium">T:</span> */}
                            <h5>{memo.fullDesc}</h5>
                        </div>
                    </div>
                    <div className="flex gap-4 justify-center text-sm text-gray-600 mb-2">
                        <div className="flex items-center gap-1">
                            <span className="font-medium">From Date:</span>
                            <Tag value={memo.fromDate} className="bg-blue-500 text-white px-3 py-1 rounded-full" />
                        </div>
                        <div className="flex items-center gap-1">
                            <span className="font-medium">To Date:</span>
                            <Tag value={memo.toDate} className="bg-yellow-500 text-white px-3 py-1 rounded-full" />
                        </div>
                    </div>

                    <div
                        className="text-lg text-gray-800"
                        dangerouslySetInnerHTML={{ __html: cleanHtmlContent(memo.htmlContent) }}
                    />
                </div>
            </div>
        )
    }

    return (
        <div>
            <div className="card-header">
                <h5 className="text-2xl mb-4">Bulletin Nova</h5>
            </div>

            <div className="card-header">
                <Carousel
                    value={gridDataSource}
                    itemTemplate={memoTemplate}
                    numVisible={1}
                    numScroll={1}
                    circular
                    autoplayInterval={1500}
                    showNavigators
                />
            </div>

        </div>
    );
};

export default LandingPage;
